import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";

import {
  FileCheck,
  ShieldAlert,
  Scale,
  BarChart3,
  Award,
  CheckCircle2,
  Video,
  MessageCircle,
  PhoneCall,
  BookUser,
  Mail,
  Locate,
} from "lucide-react";
import Accordion from "../../components/Accordion";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/b5a2d98e-28c1-4afd-adff-b1f51bdaba9f" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_gallery2.field_media_image,field_gallery3.field_media_image," +
  "field_imagen14.field_media_image,field_imagen1.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_gallery1,field_gallery2,field_gallery3,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen14,field_imagen1" +
  "&fields[media--image]=field_media_image";

function Contacto() {
  const processContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://portales.utpl.edu.ec/beportales/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };

  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />
          </>
        }
      ></BlockImageCabecera>
      <div
        className="text-center max-w-6xl px-0 sm:px-6 m-auto py-12"
        dangerouslySetInnerHTML={{
          __html: data.bloque1,
        }}
      />

      <section className="px-6 max-w-7xl mx-auto pb-12 link-with-arrow-1">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {/* 1. Zoom (bloque2) */}
          <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
            <div className="p-3 mb-3 rounded-full bg-blue-50 text-blue-600">
              <Video className="w-6 h-6" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: data?.bloque2 }} />
          </div>

          {/* 2. WhatsApp (bloque3) */}
          <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
            <div className="p-3 mb-3 rounded-full bg-emerald-50 text-emerald-600">
              <MessageCircle className="w-6 h-6" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: data?.bloque3 }} />
          </div>

          {/* 3. Línea Gratuita (bloque4) */}
          <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
            <div className="p-3 mb-3 rounded-full bg-indigo-50 text-indigo-600">
              <PhoneCall className="w-6 h-6" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: data?.bloque4 }} />
          </div>

          {/* 4. Directorio Institucional (bloque5) */}
          <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
            <div className="p-3 mb-3 rounded-full bg-amber-50 text-amber-600">
              <BookUser className="w-6 h-6" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: data?.bloque5 }} />
          </div>

          {/* 5. Correo Institucional (bloque6) */}
          <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
            <div className="p-3 mb-3 rounded-full bg-rose-50 text-rose-600">
              <Mail className="w-6 h-6" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: data?.bloque6 }} />
          </div>

          {/* 6. centros) */}
          <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
            <div className="p-3 mb-3 rounded-full bg-sky-50 text-sky-600">
              <Locate className="w-6 h-6" />
            </div>

            <div dangerouslySetInnerHTML={{ __html: data?.bloque7 }} />
          </div>
        </div>
      </section>

      <section className="px-0 sm:px-6  max-w-6xl mx-auto py-12">
        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque2,
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque3,
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque4,
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque5,
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque6,
          }}
        />
      </section>

      <BlockLeftImage
        src={data.imagen1}
        content={
          <div
            dangerouslySetInnerHTML={{
              __html: data.bloque1,
            }}
          />
        }
      ></BlockLeftImage>

      <section className="py-24 bg-slate-50">
        <div className="px-6 sm:px-0  max-w-4xl mx-auto ">
          <div
            className="text-center"
            dangerouslySetInnerHTML={{
              __html: data.bloque2,
            }}
          />

          <div className="link-with-arrow-1">
            <Accordion
              title="Documentos POA"
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque3,
                  }}
                />
              }
            ></Accordion>
          </div>
        </div>
      </section>

      <section className="w-full py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {/* Bloque 1: Rendición de Cuentas */}
            <div className="bg-white rounded-2xl p-6  shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-6">
                  <FileCheck className="w-6 h-6 stroke-[2]" />
                </div>

                <div
                  className="button-a"
                  dangerouslySetInnerHTML={{
                    __html: data?.bloque4,
                  }}
                />
              </div>
            </div>

            {/* Bloque 2: LOTAIP */}
            <div className="bg-white rounded-2xl p-6  shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-6">
                  <ShieldAlert className="w-6 h-6 stroke-[2]" />
                </div>

                <div
                  className="button-a"
                  dangerouslySetInnerHTML={{
                    __html: data?.bloque5,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w-full py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {/* Bloque 1: Certificaciones */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-xl bg-violet-50 text-violet-600 flex items-center justify-center mb-6">
                  <Award className="w-6 h-6 stroke-[2]" />
                </div>

                <div
                  className="button-a"
                  dangerouslySetInnerHTML={{
                    __html: data?.bloque12,
                  }}
                />
              </div>
            </div>

            {/* Bloque 2: Calidad */}
            <div className="bg-white rounded-2xl p-6   shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center mb-6">
                  <CheckCircle2 className="w-6 h-6 stroke-[2]" />
                </div>

                <div
                  className="button-a"
                  dangerouslySetInnerHTML={{
                    __html: data?.bloque13,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w-full py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {/* Bloque 1: Normativa */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center mb-6">
                  <Scale className="w-6 h-6 stroke-[2]" />
                </div>

                <div
                  className="link-with-arrow-1"
                  dangerouslySetInnerHTML={{
                    __html: data?.bloque6,
                  }}
                />
              </div>
            </div>

            {/* Bloque 2: Informes */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300 flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center mb-6">
                  <BarChart3 className="w-6 h-6 stroke-[2]" />
                </div>

                <div
                  className="mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data?.bloque7,
                  }}
                />

                <Accordion
                  title="Costos, aranceles, matrículas y derechos"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.bloque8,
                        }}
                      />
                    </>
                  }
                ></Accordion>

                <Accordion
                  title="Ejecución presupuestaria"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.bloque9,
                        }}
                      />
                    </>
                  }
                ></Accordion>

                <Accordion
                  title="Estados financieros auditados"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.bloque10,
                        }}
                      />
                    </>
                  }
                ></Accordion>

                <Accordion
                  title="Remuneraciones"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.bloque11,
                        }}
                      />
                    </>
                  }
                ></Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-slate-50 py-24">
        <BlockRightImage
          src={data.imagen14}
          content={
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque14,
              }}
            />
          }
        ></BlockRightImage>
      </div>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default Contacto;
